import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "notification_prices",
    object: "notification_price",
    header: [
      { text: "Date", value: "created_at" },
      { text: "ID", value: "id", sortable: false },
      { text: "Product Price", value: "product_price_id", sortable: false },
      { text: "User", value: "user", sortable: false },
      { text: "Show", value: "show_all", sortable: false },
      { text: "Actions", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
